import React from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import CountUp from "@/components/CountUp";

const SERVICES = [
  {
    id: "ecommerce",
    title: "Ecommerce",
    idx: "01",
    lead: "Storefronts, apps, and merchant workflows that convert and stay operable.",
    pain: "Checkout friction, themes that fight conversion, and apps that never match how merchants actually work.",
    build: "Shopify themes & apps, storefront UX, catalog architecture, and growth-ready integrations.",
    tags: ["Shopify", "Storefront UX", "Apps", "Conversion"],
  },
  {
    id: "saas",
    title: "SaaS",
    idx: "02",
    lead: "Multi-tenant products with billing, admin, and a delivery harness that keeps shipping safe.",
    pain: "Roadmaps outrun the platform. Auth, tenancy, and billing become the real product while features stall.",
    build: "Rails / Nest APIs, React admin surfaces, tenancy, billing, and CI that protects the main path.",
    tags: ["Rails / Nest", "React", "APIs", "Billing"],
  },
  {
    id: "ai",
    title: "AI",
    idx: "03",
    lead: "Agents, RAG, and evals built to ship—not demo slides that age out after kickoff.",
    pain: "AI pilots that never leave the sandbox, or production agents with no observability or human loop.",
    build: "Agent workflows, retrieval, eval harnesses, and LLM ops that stay maintainable.",
    tags: ["Agents", "RAG", "Evals", "LLM ops"],
  },
];

export default function ServicesPage() {
  return (
    <section className="services page-pad">
      <div className="wrap">
        <Reveal className="section__head">
          <p className="eyebrow">Services</p>
          <h1 className="page-title">Three lanes. One standard of craft.</h1>
          <p>
            Ecommerce, SaaS, and AI — senior-owned delivery underneath your stack. We harden what you already run, then
            extend it with systems that stay maintainable.
          </p>
        </Reveal>

        <Reveal className="page-metrics" delay={80}>
          <div className="page-metric">
            <strong>
              <CountUp to={3} />
            </strong>
            <span>Practice lanes</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={12} suffix="+" />
            </strong>
            <span>Years shipping</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={100} suffix="%" />
            </strong>
            <span>Senior-owned</span>
          </div>
        </Reveal>

        <div className="service-grid">
          {SERVICES.map((s, i) => (
            <Reveal as="article" className="service" key={s.id} id={s.id} delay={120 + i * 110}>
              <div className="service__top">
                <h2>{s.title}</h2>
                <span className="service__idx">{s.idx}</span>
              </div>
              <p className="service__lead">{s.lead}</p>
              <div className="service__pain">
                <strong>The pain</strong>
                {s.pain}
              </div>
              <div className="service__pain">
                <strong>What we build</strong>
                {s.build}
              </div>
              <div className="service__tags">
                {s.tags.map((t) => (
                  <span className="tag" key={t}>
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="page-cta" delay={200}>
          <Link className="btn" to="/contact">
            Start a project
          </Link>
          <Link className="btn btn--ghost" to="/apps">
            See our apps
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
